class FunctionTools {
  // 碳积分千克与克之间换算
  static conversionNum(oldNum) {
    if (Math.abs(oldNum) >= 1000) {
      return String(oldNum).includes(".")
        ? `${(oldNum / 1000).toFixed(2)}t`
        : `${oldNum / 1000}t`;
    } else if (Math.abs(oldNum) >= 1) {
      return String(oldNum).includes(".")
        ? `${oldNum.toFixed(2)}kg`
        : `${oldNum}kg`;
    } else {
      return `${(oldNum * 1000).toFixed(0)}g`;
    }
  }
  static browser = {
    versions: (function() {
      const u = navigator.userAgent;
      return {
        // 移动终端浏览器版本信息   app 等于navigator.appVersion;
        trident: u.indexOf("Trident") > -1, // IE内核
        presto: u.indexOf("Presto") > -1, // opera内核
        webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或uc浏览器
        iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, // 是否iPad
        webApp: u.indexOf("Safari") === -1 // 是否web应该程序，没有头部与底部
      };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
  static getUrlParam(paramName) {
    let [paramValue, isFound] = ["", !1];
    if (window.location.hash.split("?").length < 2) {
      return null;
    }
    const paramUrl = window.location.hash.split("?")[1];
    if (paramUrl.indexOf("=") > -1) {
      const arrSource = paramUrl.split("&");
      let i = 0;
      while (i < arrSource.length && !isFound) {
        const item = arrSource[i];
        if (
          item.includes("=") &&
          item.split("=")[0].toLowerCase() === paramName.toLowerCase()
        ) {
          paramValue = item.split("=")[1];
          isFound = !0;
        }
        i++;
      }
    }
    if (paramValue === "") {
      paramValue = null;
    }
    return paramValue;
  }
  // 校验版本
  static judgeVersion(ver) {
    if (!ver || !ver.includes(".")) {
      return false;
    }
    let version = this.getUrlParam("version") || "0.0.0";
    version = version.split(".");
    ver = ver.split(".");
    if (Number(version[0]) > Number(ver[0])) {
      // 当前大版本号大于指定
      return true;
    } else if (
      Number(version[0]) === Number(ver[0]) &&
      Number(version[1]) > Number(ver[1])
    ) {
      // 小版本号
      return true;
    } else if (
      Number(version[0]) === Number(ver[0]) &&
      Number(version[1]) === Number(ver[1])
    ) {
      // 小版本号相同
      if (Number(version[2]) >= Number(ver[2])) {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  static deepClone(source) {
    // 深拷贝
    const targetObj = source.constructor === Array ? [] : {}; // 判断复制的目标是数组还是对象
    for (const keys in source) {
      // 遍历目标
      if (source.hasOwnProperty(keys)) {
        if (source[keys] && typeof source[keys] === "object") {
          // 如果值是对象，就递归一下
          // 注释 targetObj[keys] = source[keys].constructor === Array ? [] : {};
          targetObj[keys] = this.deepClone(source[keys]).value;
        } else {
          // 如果不是，就直接赋值
          targetObj[keys] = source[keys];
        }
      }
    }
    return { value: targetObj };
  }

  static isPoneAvailable(phone) {
    const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return myreg.test(phone);
  }

  static formatTimeStr(date) {
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let minute = date.getMinutes();
    minute = minute < 10 ? "0" + minute : minute;
    let second = date.getSeconds();
    second = second < 10 ? "0" + second : second;
    return `${y}-${m}-${d} ${h}:${minute}:${second}`;
  }

  static debouce(vue) {
    return new Promise((resolve, reject) => {
      vue.delayThick && clearTimeout(vue.delayThick);
      vue.delayThick = setTimeout(() => {
        resolve();
        clearTimeout(this.vue);
      }, 600);
    });
  }
  // 防抖
  static debounce(fn, delay) {
    let timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, arguments); // 把参数传进去
      }, delay);
    };
  }
  // 可提取到tool作为工具函数，时间段格式化函数
  static formatDate(dateArrayStr) {
    const dateRange = JSON.parse(dateArrayStr) || [];
    const dateRangeStrArr = [];
    if (dateRange.length <= 0) {
      return "";
    }
    for (let i = 0; i <= dateRange.length - 1; i++) {
      const time1 =
        (dateRange[i][0] + "").split("").length > 3
          ? `${(dateRange[i][0] + "").substr(0, 2)}:${(
              dateRange[i][0] + ""
            ).substr(2, 2)}`
          : `0${(dateRange[i][0] + "").substr(0, 1)}:${(
              dateRange[i][0] + ""
            ).substr(1, 2)}`;
      const flatDate1 = `${dateRange[i][0] + "" === "0" ? "00:00" : time1}`;
      const time2 =
        (dateRange[i][1] + "").split("").length > 3
          ? `${(dateRange[i][1] + "").substr(0, 2)}:${(
              dateRange[i][1] + ""
            ).substr(2, 2)}`
          : `0${(dateRange[i][1] + "").substr(0, 1)}:${(
              dateRange[i][1] + ""
            ).substr(1, 2)}`;
      const flatDate2 = `${dateRange[i][1] + "" === "0" ? "00:00" : time2}`;
      dateRangeStrArr.push(`${flatDate1}-${flatDate2}`);
    }
    return dateRangeStrArr.join(" ; ");
  }
  // 判断是微信环境还是QQ环境
  // eslint-disable-next-line camelcase
  static isWX_QQ_web() {
    if (this.browser.versions.mobile) {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger\/[0-9]/i)) {
        return "weixin";
      }
      if (ua.match(/QQ\/[0-9]/i)) {
        return "QQ";
      }
      if (ua.match(/Alipay/i) == "alipay") {
        return "alipay";
      }
      if (this.browser.versions.ios) {
        // 是否在IOS浏览器打开
        return "iosWeb";
      }
      if (this.browser.versions.android) {
        // 是否在安卓浏览器打开
        return "andriodWeb";
      }
    } else {
      return "PCWeb";
    }
    return "";
  }
  static checkVersion(num) {
    let version = this.getUrlParam("version") || "";
    version = version.replace(/\./g, "");
    if (version < num) {
      return false;
    }
    return true;
  }

  static checkTerminal() {
    let result = "";
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      // 判断iPhone|iPad|iPod|iOS
      result = "ios";
    } else if (/(Android)/i.test(navigator.userAgent)) {
      // 判断Android
      result = "android";
    }
    return result;
  }
  // 输入框失去焦点
  static inputBlur() {
    setTimeout(() => {
      if (
        document.activeElement.tagName === "INPUT" ||
        document.activeElement.tagName === "TEXTAREA"
      ) {
        return;
      }
      let result = "pc";
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        // 判断iPhone|iPad|iPod|iOS
        result = "ios";
      } else if (/(Android)/i.test(navigator.userAgent)) {
        // 判断Android
        result = "android";
      }
      if (result === "ios") {
        document.activeElement.scrollIntoViewIfNeeded(true);
        // IOS 键盘收起后操作
        // 微信浏览器版本6.7.4+IOS12会出现键盘收起后，视图被顶上去了没有下来
        const wechatInfo = window.navigator.userAgent.match(
          /MicroMessenger\/([\d\.]+)/i
        );
        if (!wechatInfo) {
          return;
        }
        const wechatVersion = wechatInfo[1];
        const version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        if (+wechatVersion.replace(/\./g, "") >= 674 && +version[1] >= 12) {
          console.log(
            Math.max(
              document.body.clientHeight,
              document.documentElement.clientHeight
            )
          );
          window.scrollTo(
            0,
            Math.max(
              document.body.clientHeight,
              document.documentElement.clientHeight
            )
          );
        }
      }
    }, 100);
  }
  static checkPhone(phoneNumber) {
    const re = /^1\d{10}$/g;
    return re.test(phoneNumber) ? "" : "手机号错误";
  }
  // 设置页面标题
  static setTitle = function(title) {
    document.title = title;
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    const d = function() {
      setTimeout(function() {
        iframe.removeEventListener("load", d);
        document.body.removeChild(iframe);
      }, 0);
    };
    iframe.addEventListener("load", d);
    document.body.appendChild(iframe);
  };
  // 限流
  static throttle = function(fn, cycle) {
    let start = +Date.now();
    let now;
    let timer;
    return function() {
      now = +Date.now();
      clearTimeout(timer);
      if (now - start >= cycle) {
        fn.apply(this, arguments);
        start = now;
      } else {
        timer = setTimeout(() => {
          fn.apply(this, arguments);
        }, cycle);
      }
    };
  };

  //删除对象中的空值
  static deleteEmpty = function(obj) {
    if (!obj) {
      return;
    }
    Object.keys(obj).forEach(item => {
      if (
        (obj[item] === undefined || obj[item] === null || obj[item] === "") &&
        obj[item] !== 0
      ) {
        delete obj[item];
      }
    });
  };

  static copyText = function(text) {
    // 数字没有 .length 不能执行selectText 需要转化成字符串
    console.log("接受为：", text);
    if (text) {
      const textString = text.toString();
      let input = document.querySelector("#copy-input");
      if (!input) {
        input = document.createElement("input");
        input.id = "copy-input";
        input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
        input.style.position = "absolute";
        input.style.left = "-1000px";
        input.style.zIndex = "-1000";
        document.body.appendChild(input);
      }
      input.value = textString;
      // ios必须先选中文字且不支持 input.select();
      selectText(input, 0, textString.length);
      console.log(document.execCommand("copy"), "execCommand");
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        return true;
      }
      input.blur();
      // input自带的select()方法在苹果端无法进行选择，所以需要自己去写一个类似的方法
      // 选择文本。createTextRange(setSelectionRange)是input方法
      function selectText(textbox, startIndex, stopIndex) {
        if (textbox.createTextRange) {
          //ie
          const range = textbox.createTextRange();
          range.collapse(true);
          range.moveStart("character", startIndex); //起始光标
          range.moveEnd("character", stopIndex - startIndex); //结束光标
          range.select(); //不兼容苹果
        } else {
          //firefox/chrome
          textbox.setSelectionRange(startIndex, stopIndex);
          textbox.focus();
        }
      }
    }
  };
}

export default FunctionTools;



// WEBPACK FOOTER //
// ./src/starcharge/utils/functionTools.js